import { NOMBRE_FUERZA } from "./fuerza"

/** Rojo, ámbar o verde, y siempre el nombre escrito: el color no va solo (WCAG 1.4.1). */
const COLOR = [
  "var(--destructive)",
  "var(--destructive)",
  "var(--warning)",
  "var(--success)",
  "var(--success)",
] as const

export function MedidorFuerza({ fuerza }: { fuerza: number }) {
  const nivel = Math.min(Math.max(Math.round(fuerza), 0), 4)
  const color = COLOR[nivel] ?? "var(--fg-muted)"
  return (
    <span className="inline-flex items-center gap-2 text-xs" style={{ color: "var(--fg-muted)" }}>
      <span className="flex gap-1" aria-hidden={true}>
        {[1, 2, 3, 4].map((paso) => (
          <span
            key={paso}
            className="h-1.5 w-5 rounded-full"
            style={{ backgroundColor: paso <= nivel ? color : "var(--border)" }}
          />
        ))}
      </span>
      <span>{NOMBRE_FUERZA[nivel] ?? ""}</span>
    </span>
  )
}
